import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="relative mb-10 md:mb-14 overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cinematic%20collage%20with%20film%20grain%20texture%2C%20warm%20coral%20and%20amber%20tones%2C%20artistic%20comic%20panel%20aesthetic%2C%20dramatic%20composition%2C%20stylized%20webtoon%20art%20elements%2C%20soft%20atmospheric%20lighting%2C%20editorial%20photography%20style%2C%20minimal%20design&width=1200&height=600&seq=cta-home&orientation=landscape"
              alt="韩漫漫画 - 下拉式阅读体验"
              title="免费韩国漫画下拉式阅读"
              className="w-full h-auto object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
          </div>

          <div className="space-y-2 mb-8 md:mb-10">
            <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              <em className="text-accent-500 not-italic">免费</em> ·{' '}
              <em className="text-primary-500 not-italic">下拉式</em> ·{' '}
              <em className="text-accent-500 not-italic">沉浸式</em>
            </p>
            <p className="text-xl md:text-2xl font-heading text-foreground-700">
              随时随地，畅享韩国漫画
            </p>
          </div>

          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-10 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            牢记此网址，随时开启阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}